<template>
  <div class="about">
    <div class="head-title">
      <div
        class="head-bg"
        :style="{ backgroundImage: `url('${require('@/assets/img/stars.webp')}')` }"
      ></div>
      <h3 class="section-title">Portfolio</h3>
    </div>
    <b-container class="text-center">
      <b-row class="justify-content-center" style="margin: 7vh auto">
        <b-card
          v-for="(porto, index) in portos"
          :key="index"
          overlay
          :img-src="porto.img"
          img-alt="Card Image"
          text-variant="white"
          style="max-width: 20rem; height: 10em; overflow: hidden; margin: .5em;"
        >
          <div class="middle">
            <div class="text">
              <div class="title">{{porto.title}}</div>
              <div class="desc">{{porto.desc}}</div>
              <b-button pill variant="outline-light" :href="porto.githubLink" target="_blank">&gt; &gt; Github Repo</b-button>
            </div>
          </div>
        </b-card>
        <b-card
          overlay
          :img-src="require('@/assets/img/coding.webp')"
          img-alt="Card Image"
          text-variant="white"
          style="max-width: 20rem; height: 10em; overflow: hidden; margin: .5em;"
        >
          <div class="middle">
            <div class="text">
              <div class="title">See more</div>
              <div class="desc"></div>
              <b-button
                pill
                variant="outline-light"
                href="https://github.com/rzwibowo"
                target="_blank"
              >&gt; &gt; My Github</b-button>
            </div>
          </div>
        </b-card>
      </b-row>
      <b-row class="justify-content-center">
        <small class="text-muted" style="width: 100%">
          Header background by
          <a
            href="https://unsplash.com/@alexmachado?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
            target="_blank"
          >Alex Machado</a>
        </small>
        <small class="text-muted">
          Coding photo by
          <a
            href="https://unsplash.com/@ilyapavlov?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
            target="_blank"
          >Ilya Pavlov</a>
        </small>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      portos: [
        {
          title: 'Virtual Map',
          desc: `Map apps for elementary school student to learn Indonesian's teritory and it's cultures`,
          img: require('@/assets/img/vmap.webp'),
          githubLink: 'https://github.com/rzwibowo/media_ajar'
        },
        {
          title: 'SPK Taekwondo',
          desc: `Help to decide best Taekwondo's training ground in town`,
          img: require('@/assets/img/taekwondo.webp'),
          githubLink: 'https://github.com/rzwibowo/spk-taekwondo'
        },
        {
          title: 'smeswae',
          desc: `Anywhere, anytime, blast message to anyone just from the web browser`,
          img: require('@/assets/img/smswae.webp'),
          githubLink: 'https://github.com/rzwibowo/smeswae'
        },
        {
          title: 'Sistem Informasi Desa',
          desc: `Manage civil administration data`,
          img: require('@/assets/img/penduduk.webp'),
          githubLink: 'https://github.com/Sahrun/SID'
        },
        {
          title: 'SPK Beasiswa',
          desc: `Helps to decide anyone who worth to receive scholarship`,
          img: require('@/assets/img/beasiswa.webp'),
          githubLink: 'https://github.com/rzwibowo/spk-beasiswa'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.card.text-white {
  box-shadow: 0px 0px 5px 5px #ccc;
  transition: 0.5s ease;

  img {
    transition: 0.5s ease;
    opacity: 1;
  }

  &:hover {
    box-shadow: none;
    transition: 0.5s ease;

    img {
      opacity: 0.5;
      filter: blur(5px);
    }

    .middle {
      opacity: 1;
    }
  }
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.text {
  background-color: rgba(19, 113, 169, 0.5);
  color: white;
  font-size: 16px;
  width: 100%;
  height: 100%;
  padding: 1em;

  & > .title {
    font-weight: bold;
  }

  & > .desc {
    margin: 0.5em auto;
    height: 40%;
  }
}
</style>
